import { Component, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-custom-snackbar',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.css']
})
export class CustomSnackbarComponent {
  constructor(
    @Optional() @Inject(MAT_SNACK_BAR_DATA) public data: { message: string, type: string } = { message: 'Notification', type: 'success' },
    @Optional() private snackBarRef: MatSnackBarRef<CustomSnackbarComponent> | null = null
  ) {}

  getIconClass(): string {
    switch (this.data.type) {
      case 'danger':
        return 'danger-icon';
      case 'warning':
        return 'warning-icon';
      case 'success':
      default:
        return 'success-icon';
    }
  }

  getIcon(): string {
    switch (this.data.type) {
      case 'danger':
        return 'close';
      case 'warning':
        return 'warning';
      case 'success':
      default:
        return 'check';
    }
  }

  close() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
  }
} 